module.exports = __webpack_public_path__ + "static/media/cortinas.7b4e22ae.jpg";